import CustomTable from './customTable'

export default CustomTable
